"use client";

import { useAutoJoinWaitlist } from "../hooks/useAutoJoinWaitlist";

export default function AutoJoinWaitlist() {
  useAutoJoinWaitlist();
  return null;
}
